import type { FaireProductEntity } from "../../entity_types/product";

export const p_tx288f7usy: FaireProductEntity = {
  token: "p_tx288f7usy",
  type: "product",
  name: "Ocean Jasper Little Buddies, Set of 30 Pieces",
  brandToken: "b_52zr2whq85",
  brandName: "Jensen Rocks",
  imageUrl:
    "https://cdn.faire.com/fastly/5953070233d492b58cd42d55ded0d237e869d981160ba11816b4f8787a63937f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e61f32909b8991be530219ba7f5e6a467020a83f04f285bbf1c0fde281655991.jpeg",
  ],
  priceDollars: 41.57,
  description:
    'Our Ocean Jasper Little buddies are vibrant, multi-colored stones, with spherical patterns that resemble waves or bubbles. Colors vary widely, including shades of green, white, blue, yellow, red, pink and brown, often with contrasting "orbs" or eyes.\n\nLittle Buddies are half the size of a Worry Stone. They are a great size for your pocket!\n\nPhotos accurately represent the product you will receive.\n\nSlight variations in color, size and natural formation are to be expected.\n\nChoose either a 30-piece lot or a 180-piece lot for our price break.\n',
  tags: [],
  msrpDollars: 83.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:47.456Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
